/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Checks whether an input string is a valid URL of an image
 *
 * @param {String} url The text to process.
 * @example
 *
 * isValidImageURL('gravatar.com/avatar/b7f7a28d830ac66a9da9b0b56ce5bc93?s=400&d=robohash&r=x');
 * // -> false
 *
 * isValidImageURL('https://gravatar.com/avatar/b7f7a28d830ac66a9da9b0b56ce5bc93?s=400&d=robohash&r=x');
 * // -> true
 *
 */

export const isValidImageURL = (url) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
};
